/**
 * #1601 D1 — when a job can't complete because the TESTING isn't finished, the
 * way out is the tech's testing workflow (/field/backflow/<jobId>), which the
 * office job page and the field job screen never linked to. The server says
 * so with WORKFLOW_INCOMPLETE and either `reason: "report_not_submitted"` or a
 * tested/total count (services/jobCompletionGates.ts). Other WORKFLOW_INCOMPLETE
 * reasons (helper review, permit, work order) are fixed elsewhere — no link.
 */
export interface CompletionErrorBody {
    error?: string;
    message?: string;
    reason?: string;
    tested?: number;
}

export function needsTestingWorkflow(body: CompletionErrorBody | null | undefined): boolean {
    if (!body || body.error !== "WORKFLOW_INCOMPLETE") return false;
    return body.reason === "report_not_submitted" || typeof body.tested === "number";
}

export function testingWorkflowPath(jobId: string): string {
    return `/field/backflow/${jobId}`;
}
